document.addEventListener("DOMContentLoaded", function() {
    var rankMathTOC = document.getElementById("rank-math-toc");

    if (rankMathTOC) {
    var tocItems = rankMathTOC.querySelectorAll("p, h2");

    tocItems.forEach(function(tocItem) {
        tocItem.addEventListener("click", function(event) {
            event.preventDefault();
            this.classList.toggle("active");
            var nextElement = this.nextElementSibling;
            if (nextElement) {
            if (nextElement.style.display === "block") {
                nextElement.style.display = "none";
            } else {
                nextElement.style.display = "block";
            }
            }
        });
    });
    }
});